import React, { useEffect, useState } from "react";
import { CModal, CModalBody } from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";

import { hideAddTierModal, showAddTierModal } from "../redux/tierModalDispatcher";
import { addTierRequest } from "../redux/tierDispatcher";

const AddTier = ({
  buttonLabel = "Add Tier",
  editMode = false,
  tierData = {},
}) => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tierName, setTierName] = useState("");
  const [adLimitMotors, setAdLimitMotors] = useState("");
  const [adLimitProperties, setAdLimitProperties] = useState("");
  const [adLimitJobs, setAdLimitJobs] = useState("");
  const [photosPerAd, setPhotosPerAd] = useState("");
  const [videosPerAd, setVideosPerAd] = useState("");
  const [visibilityLevel, setVisibilityLevel] = useState("standard");
  const [reportingLevel, setReportingLevel] = useState("none");
  const [hasProfilePage, setHasProfilePage] = useState(false);
  const [crmFeatures, setCrmFeatures] = useState("basic");
  const [apiAccess, setApiAccess] = useState(false);
  const [description, setDescription] = useState("");
  const [spotlight, setSpotlight] = useState("");
  const [bump, setBump] = useState("");
  const [primarySector, setPrimarySector] = useState("Motors");

  const [price, setPrice] = useState(""); // 🔹 New price state

  // load data in edit mode
  useEffect(() => {
    if (editMode && tierData) {
      setTierName(tierData.name || "");
      setAdLimitMotors(tierData.ads_motors_limit || "");
      setPrimarySector(tierData.sector || "");

      setAdLimitProperties(tierData.ads_property_limit || "");
      setAdLimitJobs(tierData.ads_jobs_limit || "");
      setPhotosPerAd(tierData.photos_limit || "");
      setVideosPerAd(tierData.videos_limit || "");
      setVisibilityLevel(tierData.visibility_level || "basic");
      setReportingLevel(tierData.reporting_level || "none");
      setHasProfilePage(tierData.has_profile_page === 1);
      setCrmFeatures(tierData.crm_features || "basic");
      setApiAccess(tierData.api_access === 1);
      setDescription(tierData.description || "");
      setPrice(tierData.price || 0); // 🔹 pre-fill price if editing
      setSpotlight(tierData.spotlight || 0);
      setBump(tierData.bump || 0);

    }
  }, [editMode, tierData]);

  const resetForm = () => {
    setTierName("");
    setAdLimitMotors("");
    setPrimarySector("");
    setAdLimitProperties("");
    setAdLimitJobs("");
    setPhotosPerAd("");
    setVideosPerAd("");
    setVisibilityLevel("basic");
    setReportingLevel("none");
    setHasProfilePage(false);
    setCrmFeatures("basic");
    setApiAccess(false);
    setDescription("");
    setPrice(""); // 🔹 reset price
    setSpotlight("");
    setBump("");

  };

  const handleAddTier = () => {
    if (tierName.trim() === "") {
      alert("Tier name is required");
      return;
    }

    if (primarySector.trim() === "") {
      alert("Tier sector is required");
      return;
    }

    const data = {
      name: tierName,
      ads_motors_limit: adLimitMotors,
      ads_property_limit: adLimitProperties,
      ads_jobs_limit: adLimitJobs,
      photos_limit: photosPerAd,
      videos_limit: videosPerAd,
      visibility_level: visibilityLevel,
      reporting_level: reportingLevel,
      has_profile_page: hasProfilePage ? 1 : 0,
      crm_features: crmFeatures,
      api_access: apiAccess ? 1 : 0,
      description: description,
      price: price || 0, // 🔹 send price
      spotlight: spotlight || 0, // 🔹 send price
      bump: bump || 0, // 🔹 send price
      sector:primarySector,
    };

    if (editMode) {
      data.id = tierData.id;
    }

    dispatch(addTierRequest(data));
    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddTierModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) resetForm();
          setIsModalVisible(true);
          dispatch(showAddTierModal());
        }}
        style={{
          backgroundColor: editMode ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode ? "10px" : "14px",
          minWidth: "60px",
          height: editMode ? "24px" : "30px",
          padding: editMode ? "2px 5px" : "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttonLabel}
      </button>

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"
      >
        <CModalBody className="main-container createAdmin">
          <div className="cross-btn-div d-flex">
            <img
              onClick={() => setIsModalVisible(false)}
              src={crossButton}
              alt="close"
              className="cross-button"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            <div className="mb-4">
              <h4
                className="h4 fw-bold"
                style={{ color: "#007bff", textAlign: "center" }}
              >
                <b>{editMode ? "Edit Tier" : "Add New Tier"}</b>
              </h4>
            </div>





            {/* Tier Name */}
            <div className="mb-3">
              <label className="form-label fw-bold">Tier Name</label>
              <input
                value={tierName}
                onChange={(e) => setTierName(e.target.value)}
                type="text"
                className="form-control login-input"
                placeholder="Enter tier name"
              />
            </div>

            <div className="mt-3 mb-3">
              <label className="form-label fw-bold">Primary Sector</label>

              <div style={{ display: "flex", gap: "16px", marginTop: 4 }}>
                {["Motors", "Property", "Jobs", "Marketplace"].map((sector) => (
                  <label
                    key={sector}
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <input
                      type="radio"
                      name="primarySector"   // IMPORTANT: same name for grouping
                      value={sector}
                      checked={primarySector === sector}
                      onChange={(e) => setPrimarySector(e.target.value)}
                    />
                    {sector}
                  </label>
                ))}
              </div>
            </div>



            {/* Description */}
            <div className="mb-3">
              <label className="form-label fw-bold">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-control login-input"
                placeholder="Enter tier description"
                rows="3"
              />
            </div>





            {/* Price */}
            <div className="mb-3">
              <label className="form-label fw-bold">Price</label>
              <input
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="form-control login-input"
                placeholder="Enter price (default 0)"
              />
            </div>


            <div className="mb-3">
              <label className="form-label fw-bold">Total Bump</label>
              <input
                type="number"
                value={bump}
                onChange={(e) => setBump(e.target.value)}
                className="form-control login-input"
                placeholder="Total bump"
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Total Spotlight</label>
              <input
                type="number"
                value={spotlight}
                onChange={(e) => setSpotlight(e.target.value)}
                className="form-control login-input"
                placeholder="Total spotlight"
              />
            </div>

            {/* Ad Limits */}
            <div className="mb-3">
              <label className="form-label fw-bold">Motors Ads Limit</label>
              <input
                type="number"
                value={adLimitMotors}
                onChange={(e) => setAdLimitMotors(e.target.value)}
                className="form-control login-input"
                placeholder="Motors ads limit"
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Properties Ads Limit</label>
              <input
                type="number"
                value={adLimitProperties}
                onChange={(e) => setAdLimitProperties(e.target.value)}
                className="form-control login-input"
                placeholder="Properties ads limit"
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Jobs Ads Limit</label>
              <input
                type="number"
                value={adLimitJobs}
                onChange={(e) => setAdLimitJobs(e.target.value)}
                className="form-control login-input"
                placeholder="Jobs ads limit"
              />
            </div>

            {/* Media */}
            <div className="mb-3">
              <label className="form-label fw-bold">Photos Per Ad</label>
              <input
                type="number"
                value={photosPerAd}
                onChange={(e) => setPhotosPerAd(e.target.value)}
                className="form-control login-input"
                placeholder="Photos per ad"
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Videos Per Ad</label>
              <input
                type="number"
                value={videosPerAd}
                onChange={(e) => setVideosPerAd(e.target.value)}
                className="form-control login-input"
                placeholder="Videos per ad"
              />
            </div>

            {/* Visibility */}
            <div className="mb-3">
              <label className="form-label fw-bold">Visibility Level</label>
              <select
                value={visibilityLevel}
                onChange={(e) => setVisibilityLevel(e.target.value)}
                className="form-control login-input"
              >
                <option value="standard">Standard</option>
                <option value="enhanced">Enhanced</option>
                <option value="featured">Featured</option>
              </select>
            </div>

            {/* Reporting */}
            <div className="mb-3">
              <label className="form-label fw-bold">Reporting Level</label>
              <select
                value={reportingLevel}
                onChange={(e) => setReportingLevel(e.target.value)}
                className="form-control login-input"
              >
                <option value="none">None</option>
                <option value="basic">Basic</option>
                <option value="advanced">Advanced</option>
              </select>
            </div>

            {/* CRM Features */}
            <div className="mb-3">
              <label className="form-label fw-bold">CRM Features</label>
              <select
                value={crmFeatures}
                onChange={(e) => setCrmFeatures(e.target.value)}
                className="form-control login-input"
              >
                <option value="basic">Basic</option>
                <option value="full">Full</option>
                <option value="full+api">Full + API</option>
              </select>
            </div>

            {/* API Access */}
            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="apiAccess"
                checked={apiAccess}
                onChange={() => setApiAccess(!apiAccess)}
              />
              <label className="form-check-label" htmlFor="apiAccess">
                API Access
              </label>
            </div>

            {/* Profile Page */}
            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="hasProfilePage"
                checked={hasProfilePage}
                onChange={() => setHasProfilePage(!hasProfilePage)}
              />
              <label className="form-check-label" htmlFor="hasProfilePage">
                Has Profile Page?
              </label>
            </div>



            {/* Submit */}
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="button"
              onClick={handleAddTier}
            >
              {editMode ? "Update" : "Submit"}
            </button>
          </form>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddTier;
